<template>
    <div class="main" v-resize="onResize">
        <v-form
         ref="form"
         no-gutters
        >
        <v-row justify="end" class="mb-2">
            <v-spacer></v-spacer>
            <v-row justify="end" class="mr-3 mb-1">
                <v-btn class="ml-1 mr-1" @click="createCommunition" v-if="isSystemAdmin || isCommunicationAdmin" small title="Add New Communication" color="primary">ADD</v-btn>
                <v-btn class="ml-1 mr-1" v-if="isSystemAdmin || isCommunicationAdmin" 
                @click="showTemplateDialog = true" 
                title="Add/Edit Template" 
                small color="primary">Template</v-btn>
                <v-btn class="ml-1 mr-1" v-if="isSystemAdmin || isCommunicationAdmin" @click="exportCommunications" small color="primary">Export</v-btn>
                <v-btn @click="filterActive = !filterActive" class="ml-1 mr-0" small color="primary">Filters</v-btn>
            </v-row >  
        </v-row>
        <div class="filterArea" v-if="filterActive">
            <v-row justify="end" class="mt-1">
                <v-btn color="primary" icon @click="filterActive = false"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
            </v-row>
        <v-row no-gutters>
            <v-col class="mr-2">
                <v-select 
                dense
                label="Modified"  
                item-text="displayName"
                item-value="days" 
                :items="commModificationFilterList"
                v-model="modificationDate">
                </v-select>
            </v-col>
            <v-col class="ml-2 mr-2">
                <v-text-field 
                dense
                label="ID"                 
                v-model="id"
                v-on:keyup.native.enter="setFilters(false)"
                clearable>
                </v-text-field>
            </v-col>
            <v-col class="ml-2 mr-2">
                <v-text-field 
                dense
                label="Title"                
                v-model="title"
                v-on:keyup.native.enter="setFilters(false)"
                clearable>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mr-2">
                <v-select 
                dense
                label="Creation Date"  
                item-text="displayName"
                item-value="timeFrame" 
                clearable
                :items="commCreationFilterList"
                v-model="creationDate">
                </v-select>
            </v-col>
            <v-col class="ml-2 mr-2">
                <v-select 
                dense
                label="Announcement Type"  
                item-text="displayName"
                item-value="id" 
                clearable
                :items="commTypeList"
                v-model="commTypeId">
                </v-select>
            </v-col>
            <v-col class="ml-2 mr-2">
                <v-text-field 
                v-show="isSystemAdmin || isCommunicationAdmin"
                dense
                label="Permission"                 
                v-model="permission"
                v-on:keyup.native.enter="setFilters(false)"
                clearable>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters align="center">
            <v-col class="mr-2">
                 <v-text-field 
                 dense
                label="Body"
                v-on:keyup.native.enter="setFilters(false)"                 
                v-model="body">
                </v-text-field>
            </v-col>
             <v-col class="ml-2 mr-2">
               <v-row no-gutters align="center" >
                <v-col>
                <v-select 
                dense
                label="Publish"  
                item-text="displayName"
                item-value="id" 
                clearable
                class="pb-0"
                :items="commPublishList"
                v-model="publish">
                </v-select> 
                </v-col> 
                 <v-col class="pl-2">
                    <v-checkbox
                    dense
                    label="Full Display"
                    class="pb-0"
                    v-model="isDisplayFull"
                    ></v-checkbox> 
                   </v-col> 
                   </v-row>            
            </v-col>
            <v-col>
                <v-row class="mt-auto mb-auto" justify="end" >
                       <v-btn @click="setFilters(false)" small class="mr-3" color="primary">Apply Filters</v-btn>
                       <v-btn @click="clearFilters(false)" small color="primary">Clear Filters</v-btn>
                </v-row>
            </v-col>
        </v-row>
        </div>
        </v-form>
         <v-data-table
            :headers="headers"
            :items="communications"
            :loading ="dataLoading"
            loading-text="Loading... Please wait"
            class="elevation-1 mt-1"
            :height="tableHeight"
            :footer-props="{
            itemsPerPageOptions: [10,50,100,-1]
            }"
  >
     <template v-slot:header="{ headers }">
        <thead v-columns-resizable >
          <tr>
            <th v-for="(header,index) in headers" scope="col" :key="index">
              {{header.text}}
            </th>
          </tr>
        </thead>
      </template>

    <template v-slot:item="{item}">
        <tr :class="(item.id && item.id.indexOf('-') != -1)?'updateCommuication':''" class="tableContents" >
            <td  :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''" v-if="item.id && item.id.indexOf('-') == -1"> 
               <v-row justify="center">
                <v-icon v-if="item.sticky" small>mdi-pin</v-icon>
                <a @click.stop="editCommuication(item)" v-if="isSystemAdmin || isCommunicationAdmin">{{item.id}}</a>
                <span v-else>{{item.id}}</span>
               </v-row>
            </td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''" v-else>
                <v-row justify="end">
                <a @click.stop="editCommuicationUpdate(item)" v-if="isSystemAdmin || isCommunicationAdmin">{{item.id}}</a>
                <span v-else>{{item.id}}</span>
                </v-row>
            </td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''" v-if="item.id && item.id.indexOf('-') == -1">{{item.title}}</td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop updateCommunication':'updateCommunication'" v-else>{{item.title}}</td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''">{{item.created}}</td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''">{{item.modified}}</td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''">{{item.expires}}</td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''">
                <div v-if="item.isDisplayFull" v-html="item.body">
                </div>
                <br/>
                <a @click.stop="handleReadFlag(item)">{{item.isDisplayFull?'Less..':'More..'}}</a>
            </td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''">{{item.commType}}</td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''" v-if="isSystemAdmin || isCommunicationAdmin">{{item.commTemplate}}</td>
            <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''" v-if="isSystemAdmin || isCommunicationAdmin"> 
                <div v-if="item.permissions.length <100" class="permissionFull">{{item.permissions}}</div>
                <div v-else>
                <div :class="!item.displayPermission?'permission':'permissionFull'">{{item.permissions}}</div>
                <br/>
                <a @click.stop="item.displayPermission = !item.displayPermission">{{item.displayPermission?'Less..':'More..'}}</a>
                </div>
            </td>
             <td :class="(item.isDisplayFull || item.displayPermission)?'alignColumnTop':''" v-if="isSystemAdmin || isCommunicationAdmin">
                <v-row justify="end" class="pr-2" >
                <v-icon
                small
                color="primary"
                class="mr-2"                
                title="Add Update"
                @click="update(item)"
                v-if="item.id && item.id.indexOf('-') == -1"
                >
                mdi-pencil
                </v-icon>
                <v-icon
                    small
                    color="primary"
                    title="Send Notification"
                    @click="sendNotification(item)"
                >
                    mdi-email-send
                </v-icon>
                </v-row>
            </td>
        </tr>
    </template>

  </v-data-table>
  <template-create-dialog v-model="showTemplateDialog"></template-create-dialog>
  <send-notification-dialog 
  v-model="showSendNotificationDialog" 
  :userGroups="userGroups" 
  :commTitle="sendNotificationParams.commTitle"
  @sendNotification="saveNotification"></send-notification-dialog>
    </div>
</template>
<script>
import templateCreateDialog from "@/dialogs/template-create-dialog.vue";
import sendNotificationDialog from "@/dialogs/send-notification-dialog.vue";
import XLSX from 'xlsx';
export default {
    name:"CommunicaionManagement",
    components:{
        "template-create-dialog":templateCreateDialog,
        "send-notification-dialog":sendNotificationDialog
    },
    data(){
        return {
            filterActive:false,
            dataLoading:false,
            modificationDate:null,
            id:null,
            title:null,
            creationDate:null,
            commTypeId:null,
            permission:null,
            body:null,
            isDisplayFull:false,
            displayPermission:false,
            publish:null,
            headersDef:[
                {
                    text: 'ID',
                    sortable: false,
                    value: 'id',
                    width:70,
                    class:"table-headers",
                    align:"center"
                },
                { text: 'Title', value: 'title',width:160,sortable:false,class:"table-headers",align:"center" },
                { text: 'Created', value: 'created',width:100,sortable:false,class:"table-headers",align:"center" },
                { text: 'Modified', value: 'modified',width:100,sortable:false,class:"table-headers",align:"center" },
                { text: 'Expires', value: 'expires',width:100,sortable:false,class:"table-headers",align:"center" },
                { text: 'Body', value: 'body' ,width:200,sortable:false,class:"table-headers",align:"center" },
                { text: 'Type', value: 'commType',width:100,sortable:false,class:"table-headers",align:"center"  },
                { text: 'Template', value: 'commTemplate',width:130,sortable:false,class:"table-headers",align:"center"  },
                { text: 'Permissions', value: 'permissions',width:160,sortable:false,class:"table-headers",align:"center" },
                { text: 'Actions', value:'actions',width:80,sortable:false,class:"table-headers",align:"center"}
            ],
            communications:[], 
            communicationsForExport:[],  
            windowSize: {
                x: 0,
                y: 0,
            },
            showTemplateDialog:false,
            showSendNotificationDialog:false,
            userGroups:[],
            sendNotificationParams:{}
        }
    },
    computed:{
        fields(){
            return this.$store.getters.getManagementFilterFields;
        },
        commTypeList(){
            return (this.fields && this.fields.commTypeList) ? this.fields.commTypeList:[];
        },
        commModificationFilterList(){
            return (this.fields && this.fields.commModificationFilterList) ? this.fields.commModificationFilterList:[];
        },
        commCreationFilterList(){
            return (this.fields && this.fields.commCreationFilterList) ? this.fields.commCreationFilterList:[];
        },
        commPublishList(){
           return (this.fields && this.fields.commPublishList) ? this.fields.commPublishList:[]; 
        },
        tableHeight(){
            return this.filterActive?(this.windowSize.y -215-250):(this.windowSize.y - 250);
        },
        savedFilters(){
            return this.$store.getters.getSavedFilters;
        },
        isSystemAdmin(){
            return this.$store.getters.getIsSystemAdmin;
        },
        isCommunicationAdmin(){
            return this.$store.getters.getIsCommunicationAdmin;
        },
        headers(){
            if(this.isSystemAdmin || this.isCommunicationAdmin){
                return this.headersDef;
            }else{
                return this.headersDef.filter(ele => (ele.value != "actions" && 
                ele.value != "commTemplate" && ele.value !="permissions"));
            }
        }
    },
    async mounted(){
        await this.$store.dispatch("fetchManagementFilterFields");
        this.loadFilters();
        this.setFilters();
    },
    methods:{
        update(item){
           this.$router.push({name:"CommunicationUpdate",params:{communicationId:item.id}});
        },
        async sendNotification(item){
           const params = {};
           if(item.id.indexOf('-') == -1){
               params.commId = item.id;
               params.type="communication";
           }else{
               params.commId = item.id.split('-')[1];
               params.id = item.id.split('-')[0];
               params.type="update";
           }

           params.commTitle = item.title;

           this.sendNotificationParams = params;
           const response = await this.$store.dispatch("loadCommunicationUserGroup",params);
           if(response && !response.error){
               this.userGroups = response;
           }else{
               this.userGroups = [];
           }

           if(this.userGroups.length > 0){
               this.showSendNotificationDialog = true;
           }else{
               //Do not show popup when session expired
                if(this.$router.history.current.name === "CommunicaionManagement"){
                    const infoObject = {};
                    infoObject.showDlg = true;
                    infoObject.buttons={
                        CloseButton:{
                            Caption:"Close"
                        }
                    };
                    infoObject.title="Information";
                    infoObject.message="No permission group is assigned to this communication!";
                    this.$store.dispatch("setConfirmDialogDetails",infoObject);
                }
           }
        },
        async saveNotification(valuesFromSendNotificationDialog){
            const userGroup = valuesFromSendNotificationDialog.userGroups;
            const params = {};

            console.log("inside save notification : usergroups: "+userGroup+" and resend: "+valuesFromSendNotificationDialog.resend);
            params.userId = this.$store.getters.getUserId;
            params.selectedRepGroups = userGroup;
            params.isResend = valuesFromSendNotificationDialog.isResend;
            if(this.sendNotificationParams.type =="update"){
                params.commId = this.sendNotificationParams.id;
                params.commUpdateId = this.sendNotificationParams.commId;
            }else{
                params.commId = this.sendNotificationParams.commId;
                params.commUpdateId = null;
            }
            
            console.log("params: "+params.isResend);
            await this.$store.dispatch("saveNotification",params);
            console.log("userGroups length: "+userGroup.length);
            this.sendNotificationParams = {};
        },
        createCommunition(){
          this.$router.push("/communication/create");
        },
        async setFilters(NoSearch){
          this.saveFilters();  
          this.communications = [];
          this.communicationsForExport = [];
          if(!NoSearch){
          const commSearchRequestData = {
              modificationDate:this.modificationDate,
              creationDate:this.creationDate,
              body:this.body,
              id:(this.id && this.id != "")?this.id:null,
              commTypeId:this.commTypeId,
              title:this.title,
              permission:this.permission,
              publish:this.publish,
              fullDisplay:this.isDisplayFull
          }
          this.dataLoading = true;
          const response = await this.$store.dispatch("searchCommunications",{requestdata:commSearchRequestData,userId:this.$store.getters.getUserId});
          console.log(response);
          if(response && !response.error){
                //reload notification list and landing page items
                this.$store.dispatch("fetchNotificationList",{userId:this.$store.getters.getUserId});
                this.communications = response.map(ele =>{ 
                    const comm = ele; 
                    comm.isDisplayFull= this.isDisplayFull; 
                    comm.displayPermission = this.displayPermission; 
                    //replace permission group seprator from comma to newline
                    comm.permissions = comm.permissions != null?comm.permissions.replace(/,/gi,"\n"):"";
                    return comm;});

                    this.communicationsForExport = response.map(ele =>{ 
                    const comm = JSON.parse(JSON.stringify(ele)); 
                
                    //replace permission group seprator from comma to newline
                    comm.permissions = comm.permissions != null?comm.permissions.replace(/,/gi,"\n"):"";
                    comm.body = comm.body.replace( /(<([^>]+)>)/ig, '').replace(/&nbsp;/ig,' ').replace(/(&#(\d+);)/g, function(match, capture, charCode) {
                        return String.fromCharCode(charCode);
                    });
                    delete comm.acknowledgement;	
                    delete comm.sticky;	
                    delete comm.isRead;
                    delete comm.isDisplayFull;	
                    delete comm.displayPermission;

                    return comm;});
            }
            this.$nextTick(() =>{
                //handle resize bar position
                const thead = this.$el.querySelector('.v-data-table-header');
                const ths = thead.querySelectorAll('th');
                const resizeContainer =  this.$el.querySelector('.vue-columns-resizable');
                const bars = resizeContainer.querySelectorAll('.columns-resize-bar');

                bars.forEach((bar, index) => {
                const th = ths[index];
                const nextTh = ths[index + 1];
                th.style.width = th.offsetWidth + 'px';
                bar.style.left = nextTh.offsetLeft - 4 + 'px';
            });
            })

            this.dataLoading = false;
         }
        },
        clearFilters(NoSearch){
           this.creationDate = null;
           this.body = null;
           this.id = null;
           this.commTypeId = null;
           this.title = null;
           this.permission = null;
           this.modificationDate="all-active";
           this.isDisplayFull = false;
           this.publish = null;
           this.setFilters(NoSearch);
           this.$store.dispatch("saveCommFilters",null);
        },
        editCommuication(item){
            this.$router.push({name:"CommunicaionEditor",params:{communicationId:item.id}});
        },
        editCommuicationUpdate(item){
            const ids = item.id.split('-');
            this.$router.push({name:"CommunicationUpdate",params:{communicationId:ids[0],updateId:ids[1]}});
        },
        loadFilters(){
            if(this.$route.params && this.$route.params.showNotification){
                 this.clearFilters(true);
                 this.modificationDate="all-unread";
            }else{
                if(this.savedFilters != null){
                        this.creationDate = this.savedFilters.creationDate;
                        this.body = this.savedFilters.body;
                        this.id = this.savedFilters.id;
                        this.commTypeId = this.savedFilters.commTypeId;
                        this.title = this.savedFilters.title;
                        this.permission = this.savedFilters.permission;
                        this.modificationDate= this.savedFilters.modificationDate;
                        this.isDisplayFull = this.savedFilters.isDisplayFull;
                        this.publish = this.savedFilters.publish;
                }else{
                    this.clearFilters(true);
                }
            }
            
        },
        saveFilters(){
            const savedFilters = {};
            savedFilters.creationDate = this.creationDate;
            savedFilters.body = this.body;
            savedFilters.id = this.id;
            savedFilters.commTypeId = this.commTypeId;
            savedFilters.title = this.title;
            savedFilters.permission = this.permission;
            savedFilters.modificationDate= this.modificationDate;
            savedFilters.isDisplayFull = this.isDisplayFull;
            savedFilters.publish = this.publish;
            this.$store.dispatch("saveCommFilters",savedFilters);
        },
        onResize(){
            this.windowSize = { x: window.innerWidth, y: window.innerHeight };
        },
        exportCommunications(){
            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(this.communicationsForExport);
 
            /* add worksheet to workbook */
            XLSX.utils.book_append_sheet(wb, ws, "Communications");

            /* write workbook */
            XLSX.writeFile(wb, "REP_CommunicationList.xlsx");
        },
        async handleReadFlag(item){
            if(item.isDisplayFull){
                item.isDisplayFull = false;
            }else{
                if(item.isRead){
                   item.isDisplayFull = true; 
                }else{
                    //set read flag for communication
                    item.isRead = true;
                    this.$store.dispatch("getNotificationBody",{userId:this.$store.getters.getUserId,commId:item.id,isBodyRequired:false}).then(() =>{
                        //reload notification list and landing page items
                        this.$store.dispatch("fetchNotificationList",{userId:this.$store.getters.getUserId});
                        item.isDisplayFull = true; 
                    });
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.main{
     margin: auto;
     margin-bottom: 1%;
     width: 90%;
     padding-top: 3%;
}
.filterArea{
    border:2px lightgray solid;
    padding-left: 2%;
    padding-right: 2%;
    margin-top: 1%;
}

.permission{
    overflow:hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width:150px;
    max-height:50px;
}

.permissionFull{
    white-space: pre-line;
}

.updateCommunication{
    color:var(--v-primary-base);
}

//color for even rows
tbody tr:nth-of-type(even) {
  background-color: #f5fbfa;
}

</style>
<style lang="scss">

.v-data-table__wrapper table {
  border: 1px solid grey !important;
  border-collapse: collapse;
}

.v-data-table__wrapper table td, .v-data-table__wrapper table th {
  border: 1px solid grey !important;
}

.alignColumnTop{
    vertical-align: top !important;
}

.v-data-table__wrapper table tbody tr.tableContents td.alignColumnTop div.row{
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 auto;
    margin-top: 1px;
}


</style>